import * as angular from 'angular';
import { IController } from 'angular';
import * as _ from 'lodash';

import { RegentsSubject } from '../../../../../ng2/shared/constants/regents.constant';

class MasterProgramTableFiltersCtrl implements IController {
  // injections
  static $inject = ['$scope'];

  // bindings
  private masterProgram: any[];
  private teachers: any;
  private subjectAreas: any;
  private courseFilter: any;

  // class properties
  private valuesToFilterOn: any;
  private courseCodesMenu: any;
  private courseCodeWithSection: any;

  constructor(private $scope) {}

  // state on ctrl initialization
  $onInit() {
    const uniqueFilterFieldsValues = _.reduce(
      this.masterProgram,
      (result: any, course: any) => {
        const teachers = this.teachers(course.teachers);

        // inital result state on first iteration
        if (!_.size(result)) {
          result.subjectAreas = this.subjectAreas;
          result.teachers = {};
          result.isRegentsCulminatingString = {
            Yes: 'Yes',
            No: 'No',
          };
          result.prepsFor = _.reduce(
            RegentsSubject,
            (result, subject) => {
              result[subject.key] = subject.humanName;
              return result;
            },
            {},
          );
        }

        if (!result.teachers[teachers]) {
          result.teachers[teachers] = teachers;
        }

        return result;
      },
      {},
    );

    this.courseCodeWithSection = null;

    this.valuesToFilterOn = _.reduce(
      uniqueFilterFieldsValues,
      (result, values, field) => {
        result[field] = _.values(values)
          .filter(v => v !== null)
          .sort();
        return result;
      },
      {},
    );

    this.courseCodesMenu = _.sortBy(
      _.each(this.masterProgram, course => {
        course.courseCodeWithSection = `${course.courseCode}-${course.section}`;
        return course;
      }),
      'courseCodeWithSection',
    );

    // attached to bindings on init
    this.$scope.filterCourseCodeWithSection = function(query: string) {
      const searchTextQuery = query.toLowerCase();

      return course => {
        let courseCodeWithSection;

        if (course.courseCodeWithSection) {
          courseCodeWithSection = course.courseCodeWithSection;
        } else {
          courseCodeWithSection = `${course.courseCode}-${course.section}`;
        }

        return _.includes(course.courseCodeWithSection.toLowerCase(), searchTextQuery);
      };
    };
  }

  selectedItemChange = () => {
    this.courseFilter.courseCodeWithSection = this.courseCodeWithSection || null;
    // this.updateCourseFilter(this.courseFilter);
  };

  queryCourseCodes = (query: string) => {
    if (query) {
      this.courseFilter.courseCodeWithSection = query;
      // this.updateCourseFilter(this.courseFilter);
      return this.courseCodesMenu.filter(this.$scope.filterCourseCodeWithSection(query));
    }

    this.courseFilter.courseCodeWithSection = null;
    // this.updateCourseFilter(this.courseFilter);
    return this.courseCodesMenu;
  };
}

// angular 1.x module injection goes at the bottom of the file
angular.module('nv.SchoolMetricsModule').controller('MasterProgramTableFiltersCtrl', MasterProgramTableFiltersCtrl);
